/**
 * Student Prompts Service
 * Records student-created prompts to teacher's collection for dashboard visibility
 * Collection: teachers/{teacherId}/studentPrompts
 */

import {
  collection,
  doc,
  setDoc,
  Timestamp,
} from 'firebase/firestore';
import { db } from '../../config/firebase';
import type { StudentPromptDocument, CreateStudentPromptInput } from '../../types/firestore';

const TEACHERS_COLLECTION = 'teachers';
const PROMPTS_SUBCOLLECTION = 'studentPrompts';

/**
 * Record a student prompt to the teacher's collection
 * Called when students create custom lessons or start pronunciation practice
 */
export const recordStudentPrompt = async (
  teacherId: string,
  promptData: CreateStudentPromptInput
): Promise<StudentPromptDocument> => {
  if (!db) throw new Error('Firebase not configured');

  const promptsRef = collection(db, TEACHERS_COLLECTION, teacherId, PROMPTS_SUBCOLLECTION);
  const promptDoc = doc(promptsRef);

  const prompt: StudentPromptDocument = {
    id: promptDoc.id,
    ...promptData,
    createdAt: Timestamp.now(),
  };

  await setDoc(promptDoc, prompt);
  console.log('[StudentPrompts] Recorded prompt:', prompt.type, 'from student:', prompt.studentName);

  return prompt;
};
